import styled from "styled-components";

export const StyledFooter = styled.footer`
	width: 100%;
	margin-top: 30px;
	background-size: auto;

	display: flex;
	align-items: flex-end;
	justify-content: flex-start;


	p {
		background-color: white;
		padding: 20px;
		font-weight: bold;
		border-radius: 8px;
		border: 2px solid black;
		margin-bottom: 10px;
		margin-left: 80px;

		display: flex;
		justify-content: center;
		align-items: center;
		gap: 10px;

		a:hover {
			color: var(--blue50);
		}
	}

	@media (max-width: 600px) {
		p {
			padding: 10px;
		}
	}
`;
